import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-point-margin',
    templateUrl: './default/point-margin/point-margin.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class PointMarginComponent extends UnitsDistributionBase {
  // Used for NFL_POINT_MARGIN
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}